import axios from 'axios';
import { Howl } from 'howler';
import { SoundSource } from '../providers/ActivityAudioProvider/types';
import type { Asset } from '../graph/schema-generated-types-educator';

const DEFAULT_OPTIONS = {
  volume: 1,
};

const ERR_HOWL = (src: string, msg: string) => {
  console.warn(`There was an error loading the sound ${src}`);
  msg && console.warn(JSON.stringify(msg, null, 2));
  return new Howl({});
};

export const getSoundAsync = async ({ filename, ...options }): Promise<Howl> =>
  new Promise((resolve) => {
    const snd = new Howl({
      src: [
        filename.includes('https://') ? filename : '' /* REVISIT getTranslatedAudio(filename)*/,
      ],
      ...(options || DEFAULT_OPTIONS),
      onload: () => resolve(snd),
      onloaderror: () => resolve(new Howl({})),
    });
  });

export const loadAudioAsync = ({ src }: SoundSource | Asset, options: any = {}): Promise<Howl> =>
  new Promise((resolve) => {
    if (!src || src === '') return resolve(ERR_HOWL(src, 'Empty src string received'));

    const audio = new Howl({
      src,
      html5: false,
      ...options,
      onload: () => resolve(audio),
      onloaderror: (e: any, msg: string) => {
        resolve(ERR_HOWL(src, msg));
      },
    });
  });

export const loadCaptionObject = ({ captions }: SoundSource | Asset): Promise<any> =>
  new Promise((resolve) => {
    if (typeof captions === 'object') {
      resolve(captions);
    } else {
      if (captions) {
        axios
          .get(captions)
          .then((response) => resolve(response.data))
          .catch((err: any) => {
            console.log(err);
            resolve({ cues: [] });
          });
      } else {
        resolve({ cues: [] });
      }
    }
  });

export const transformPathToUrl = (snd: SoundSource | Asset, path: string /*, language?*/) => {
  const { REACT_APP_S3_PREFIX } = process.env;

  return {
    src: `${REACT_APP_S3_PREFIX}/${path}/${snd.src}`,
    captions: `${REACT_APP_S3_PREFIX}/${path}/${snd.captions}`,
  };
};

export const formatTimeStamp = (time: string): number => {
  const [m, s, ms] = time.split(':').map((stamp) => parseFloat(stamp));
  return parseFloat((m * 3600 + s * 60 + ms).toFixed(1));
};

export const mockSoundMap = {};
